import { connectedAccountsStore } from '../store/store';

export function getErrorConnectBasic(): boolean {
    let store = connectedAccountsStore();

    if (store.connectBasicState.advancedChecked) {
        return false;
    }

    return store.connectBasicState.emailAddress === '' || store.connectBasicState.password === '';
}
